import directMailService from '../../services/api/DirectMail';
import commonFunctions from '../../mixin/common-function-mixins';
import { DIRECT_MAIL_REPORT_CAMPAIGN_CATEGORIES_ACTION,DIRECT_MAIL_REPORT_SAVE_ACTION, DIRECT_MAIL_REPORT_BY_ID_ACTION,DIRECTMAIL_DELETE_ACTION,DIRECTMAIL_LOAD_ACTION } from '../action-types';
import { DIRECT_MAIL_REPORT_CHANGE_CAMPAIGN_NAME_MUTATION, DIRECT_MAIL_REPORT_CHANGE_CAMPAIGN_CATEGORY_MUTATION, DIRECT_MAIL_REPORT_CHANGE_CAMPAIGN_DESCRIPTION_MUTATION,
  DIRECT_MAIL_REPORT_CHANGE_DROP_DATE_MUTATION, DIRECT_MAIL_REPORT_CHANGE_INTERNAL_UNIT_MUTATION, DIRECT_MAIL_REPORT_CHANGE_JOB_ID_MUTATION,
  DIRECT_MAIL_REPORT_CHANGE_CREATIVE_MUTATION, DIRECT_MAIL_REPORT_CHANG_MAILED_MUTATION, DIRECT_MAIL_REPORT_CHANGE_INITIAL_COUNT_MUTATION,
  DIRECT_MAIL_REPORT_CHANGE_MAILED_COUNT_MUTATION, DIRECT_MAIL_REPORT_CHANGE_POSTAGE_COST_MUTATION, DIRECT_MAIL_REPORT_CHANGE_SERVICE_COST_MUTATION,
  DIRECT_MAIL_REPORT_CHANGE_OTHER_COST_MUTATION, DIRECT_MAIL_REPORT_CHANGE_ESTIMATED_COST_MUTATION ,DIRECT_MAIL_REPORT_CHANGE_ACTUAL_COST_MUTATION,
  DIRECT_MAIL_REPORT_CLEAR_MUTATION, DIRECT_MAIL_REPORT_CAMPAIGN_CATEGORIES_MUTATION, DIRECT_MAIL_REPORT_BY_ID_MUTATION, DIRECT_MAIL_REPORT_CLONE_MUTATION,
  DIRECTMAIL_LOAD_MUTATION, DIRECT_MAIL_AUDIT_LOG_MUTATION, DIRECT_MAIL_AUDIT_LOG_CLEAR_OLD_DATA_MUTATION,
  DIRECT_MAIL_REPORT_ASSIGN_NEW_TO_OLD_DATA_MUTATION} from '../mutation-types';

// initial state
export const namespaced = true;

// initial state
export const state = {
  namespaced: true,
  directMailReport:loadEmptyDirectMailReport(),
  campaignCategoryDetails:[],
  mailedDetails:[{'mailedName':'No','mailedValue':false}, {'mailedName':'Yes','mailedValue':true}],
  directMailData: [],
  oldDirectMailReport: null
};


// actions
export const actions = {
   async [DIRECT_MAIL_REPORT_CAMPAIGN_CATEGORIES_ACTION]({commit})  {
    const response = await directMailService.getDirectMailCampaignCategories();
    commit(DIRECT_MAIL_REPORT_CAMPAIGN_CATEGORIES_MUTATION, response.data);
    return response;
  },
  async [DIRECT_MAIL_REPORT_SAVE_ACTION] ({state, commit}){  
    if(!state.directMailReport.tazClientAuditLog.description)
      state.directMailReport.tazClientAuditLog = null;
    const response = await directMailService.saveDirectMailReport(state.directMailReport);  
    commit(DIRECT_MAIL_REPORT_ASSIGN_NEW_TO_OLD_DATA_MUTATION ,{directMailData: response.data})  
    return response;
  },
  async [DIRECT_MAIL_REPORT_BY_ID_ACTION]({ commit }, directMailID) {
    let response = await directMailService.getDirectMailID(directMailID);
    commit(DIRECT_MAIL_REPORT_BY_ID_MUTATION, response.data);
  },
  async [DIRECTMAIL_LOAD_ACTION]({ commit }) {
    const response = await directMailService.getDirectMails();
    commit(DIRECTMAIL_LOAD_MUTATION, response.data);
    return response.data;
  },
  async [DIRECTMAIL_DELETE_ACTION]({state}, directMailID) {
    var requestData = {directMailID: directMailID, TazClientAuditLog: state.directMailReport.tazClientAuditLog}
    const response = await directMailService.deleteDirectMail(requestData);
    return response;
  },
}

// mutations
export const mutations = {
  [DIRECT_MAIL_REPORT_CHANGE_CAMPAIGN_NAME_MUTATION](state, payLoad){
    state.directMailReport.campaignID = payLoad.campaignID;
    state.directMailReport.campaignName = payLoad.campaignName;
  },
  [DIRECT_MAIL_REPORT_CHANGE_CAMPAIGN_CATEGORY_MUTATION](state, payLoad){
    state.directMailReport.campaignCategoryID = payLoad.campaignCategoryID;
    state.directMailReport.categoryName = payLoad.categoryName;
  },
  [DIRECT_MAIL_REPORT_CHANGE_CAMPAIGN_DESCRIPTION_MUTATION](state, campaignDescription){
    state.directMailReport.campaignDescription = campaignDescription
  },
  [DIRECT_MAIL_REPORT_CHANGE_DROP_DATE_MUTATION](state, dropDate){
    state.directMailReport.dropDate = dropDate
  },
  [DIRECT_MAIL_REPORT_CHANGE_INTERNAL_UNIT_MUTATION](state, internalUnit){
    state.directMailReport.internalUnit = internalUnit
  },
  [DIRECT_MAIL_REPORT_CHANGE_JOB_ID_MUTATION](state, jobID){
    state.directMailReport.jobID = jobID
  },
  [DIRECT_MAIL_REPORT_CHANGE_CREATIVE_MUTATION](state, creative){
    state.directMailReport.creative = creative
  },
  [DIRECT_MAIL_REPORT_CHANG_MAILED_MUTATION](state, mailed){
    state.directMailReport.mailed = mailed
  },
  [DIRECT_MAIL_REPORT_CHANGE_INITIAL_COUNT_MUTATION](state, initialCount){
    state.directMailReport.initialCount = initialCount
  },
  [DIRECT_MAIL_REPORT_CHANGE_MAILED_COUNT_MUTATION](state, mailedCount){
    state.directMailReport.mailedCount = mailedCount
  },
  [DIRECT_MAIL_REPORT_CHANGE_POSTAGE_COST_MUTATION](state, postageCost){
    state.directMailReport.postageCost = postageCost
  },
  [DIRECT_MAIL_REPORT_CHANGE_SERVICE_COST_MUTATION](state, serviceCost){
    state.directMailReport.serviceCost = serviceCost
  },
  [DIRECT_MAIL_REPORT_CHANGE_OTHER_COST_MUTATION](state, otherCost){
    state.directMailReport.otherCost = otherCost
  },
  [DIRECT_MAIL_REPORT_CHANGE_ESTIMATED_COST_MUTATION](state, estimatedCost){
    state.directMailReport.estimatedCost = estimatedCost
  },
  [DIRECT_MAIL_REPORT_CHANGE_ACTUAL_COST_MUTATION](state, actualCost){
    state.directMailReport.actualCost = actualCost
  },
  [DIRECT_MAIL_REPORT_CLEAR_MUTATION](state){
    state.directMailReport = loadEmptyDirectMailReport();
  },
  [DIRECT_MAIL_REPORT_CAMPAIGN_CATEGORIES_MUTATION](state, campaignCategoryData){
    state.campaignCategoryDetails = commonFunctions.methods.sortRecords(campaignCategoryData, 'categoryName', true ); 
  },
  [DIRECT_MAIL_REPORT_BY_ID_MUTATION](state, directMailReportDetails){
    directMailReportDetails.dropDate = commonFunctions.methods.formatDate(directMailReportDetails.dropDate, 'MM-DD-YYYY');
    state.oldDirectMailReport = JSON.parse(JSON.stringify(directMailReportDetails));
    state.directMailReport = directMailReportDetails;
  },
  [DIRECT_MAIL_REPORT_CLONE_MUTATION](state){
    state.directMailReport.directMailID = 0;
  },
  [DIRECTMAIL_LOAD_MUTATION](state, directMailData) {
    directMailData.map(r =>{ r.mailed = (r.mailed && r.mailed == true) ? "Yes" : "No"});
    directMailData.map(r =>{ r.dropDate = commonFunctions.methods.formatDate(r.dropDate, 'YYYY-MM-DD')}); 
    directMailData.map(r =>{ r.utcModifiedDate = commonFunctions.methods.formatDate(r.utcModifiedDate, 'YYYY-MM-DD')}); 
    state.directMailData = directMailData
  },
  [DIRECT_MAIL_AUDIT_LOG_MUTATION](state, payLoad){
    state.directMailReport.tazClientAuditLog = payLoad
  },
  [DIRECT_MAIL_AUDIT_LOG_CLEAR_OLD_DATA_MUTATION](state){
    state.oldDirectMailReport = null
  },
  [DIRECT_MAIL_REPORT_ASSIGN_NEW_TO_OLD_DATA_MUTATION](state, directMailDetails){
    directMailDetails.directMailData.tazClientAuditLog = null;
    directMailDetails.directMailData.dropDate = commonFunctions.methods.formatDate(directMailDetails.directMailData.dropDate, 'MM-DD-YYYY');
    state.oldDirectMailReport = JSON.parse(JSON.stringify(directMailDetails.directMailData)) 
  }
}

function loadEmptyDirectMailReport(){
  return {
    directMailID: 0,
    campaignID: null,
    campaignCategoryID: null,
    campaignDescription: null,
    dropDate: null,
    internalUnit: null,
    jobID: null,
    creative: null,
    mailed:false,
    initialCount: null,
    mailedCount: null,
    postageCost: null,
    serviceCost: null,
    otherCost: null,
    estimatedCost: null,
    actualCost:null,
  }
}